
// Mouse tracker tracks mouse events on body or other html components
class EventTracker {

  constructor () {

    // state consists of set of last events
    this.state = {

      // id of handler
      lastId : 0,

      // events
      events : {
        // set of events
        global: {}
      }
    };

    // set of tracked event types
    [ "mousemove",
      "mouseout",
      "mouseenter",
      "click",
      "mousedown",
      "mouseup",
      "wheel",
      "scroll",
      "contextmenu",
      "touchmove"
    ].forEach((r) => {

      // initialize last event object
      this.state.events.global[r] = {
        date : new Date(), eventObj: null
      };
    })
  }


  // Global handler wrapper
  __globalHandlerWrapper (type, fun, event) {

    // split type for future use
    var [eventName, eventNs, eventKey] = type.split('.');
    var lastEvent = this.state.events.global[eventName];

    // call handler function with event object and type of event passed through
    fun(event, lastEvent);

    // save last event
    this.state.events.global[eventName] = event;
  }

  // component handler wrapper
  __componentHandlerWrapper (type, fun, name, event) {

    // split type for future use
    var [eventName, eventNs, eventKey] = type.split('.');
    var lastEvent = name ? this.state.events[name][eventName] : null;

    //console.log('calling fun: ', event, lastEvent, type, name);
    if (event.type == "touchmove") {
      //console.log('handling touchevent: ', lastEvent, event)
      if (lastEvent != null) {

        // compute deltas
        event.deltaY = -(event.originalEvent.touches[0].clientY - lastEvent.eventObj.originalEvent.touches[0].clientY);
        event.deltaX = -(event.originalEvent.touches[0].clientX - lastEvent.eventObj.originalEvent.touches[0].clientX);

        // y shift
        if (Math.abs(event.deltaY) > 10) {
          event.deltaY = 0;
        }

        // x shift
        if (Math.abs(event.deltaX) > 10) {
          event.deltaX = 0;
        }



      } else {
        event.deltaX = 0;
        event.deltaY = 0;
      }
    }

    // call handler function with event object and type of event passed through
    fun(event, lastEvent, type, name);

    // save last event
    if (name) {
      this.state.events[name][eventName] = {date: new Date(), eventObj: event};
    }
  }

  // Associates jquery ns keyed handler with body component
  addGlobalHandler(type, fun) {

    // assign global handler
    $('body').on(type, this.__globalHandlerWrapper.bind(this, type, fun));
  }

  // Associates jquery ns keyed handler with given component
  addComponentHandler(component, type, fun, name) {
    var [eventName, eventNs, eventKey] = type.split('.');

    var elements = (typeof component == "Array") ? component : [ component ];

    elements.forEach((el, i) => {
      var elName = elements.length > 1 ? name + "." + i : name;

      // initialize event
      if (!this.state.events[elName]) {
        this.state.events[elName] = {
          eventName: null
        };
      } else {
        this.state.events[elName][eventName] = null;
      }

      // assign global handler
      $(el).on(type, this.__componentHandlerWrapper.bind(this, type, fun, elName));

    })

  }

  // Switches on/off jquery ns keyed handler on body component
  switchGlobalHandler(ns, on) {
    this.switchComponentHandler('body', ns, on)
  }

  // Switches on/off jquery ns keyed handler on any component
  switchComponentHandler(component, ns, on) {
    var elements = (typeof component == "Array") ? component : [ component ];

    elements.forEach((el, i) => {
      on ? $(el).on(ns) : $(el).off(ns);
    })

  }

  // Switches off jquery ns keyed handler on body component
  removeGlobalHandler(ns) {
    this.switchGlobalHandler(ns, 0);
  }

  // Switches off jquery ns keyed handler on any component
  removeComponentHandler(component, ns) {
    this.switchComponentHandler(component, ns, 0);
  }

}

export default EventTracker;



// WEBPACK FOOTER //
// ./app/react/tools/EventTracker.jsx